import { render, staticRenderFns } from "./Wp_mt_pay_data.vue?vue&type=template&id=034422c1&scoped=true&"
import script from "./Wp_mt_pay_data.vue?vue&type=script&lang=js&"
export * from "./Wp_mt_pay_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034422c1",
  null
  
)

export default component.exports